// Don't delete: enables VS Code autocompletion of json prisma types
import '@signupsoftware/server/prisma-types.js'
import { createRoot } from 'react-dom/client'

// import '@unimpaired/react/style.css' // This allows our style library to work
import './index.css' // This allows tailwind to work
import { App } from './App'

import * as Sentry from '@sentry/react'
import { SENTRY_CONFIG } from './config/sentry.config'
import { setupMaintenanceInterceptor } from './config/maintenance'
import { setupApiAuthInterceptor } from './config/api-auth'
import { setupReducedMotion } from './config/reduced-motion'

Sentry.init(SENTRY_CONFIG)

// Detect the deploy's 503 maintenance response and show the maintenance screen.
setupMaintenanceInterceptor()
// Attach Firebase JWT + X-Organization-Id to every apiClient request.
setupApiAuthInterceptor()

// react-spring has no per-tree reduced-motion switch
setupReducedMotion()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
